// extracted by mini-css-extract-plugin
module.exports = {"collapse":"auditlog_collapse__2Yl8z","item":"auditlog_item__3_ke1"};